import { Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import CustomRangePicker from "../../../components/DateRangePicker";
import ClientOwnerFilterDialog from "../../../components/Dialog/ClientOwnerFilterDialog";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { fetchAllAppointments } from "../../../services/appointments";

const headerData = [
  "Ref#",
  "Client",
  "Service",
  "Created by",
  "Branch Name",
  "Created Date",
  "Scheduled Date",
  "Duration",
  "Team member",
  "Status",
];

const tableRows = [
  "appointment_id",
  "client",
  "services",
  "createdBy",
  "assingedBranch",
  "appointment_booked_date",
  "appointment_shedule_date",
  "appointment_duration",
  "teamMember",
  "appointment_status",
];

function Appointments() {
  const openDialog = useRef();
  const currentYear = moment().year();
  const [searchInput, setSearchInput] = useState("");
  const [endDate, setEndDate] = useState(moment(`${currentYear}-12-31`));
  const [startDate, setStartDate] = useState(moment(`${currentYear}-01-01`));
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [isLoading, setIsLoading] = useState(false);
  const [allAppointments, setAllAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch) handleFetchBusinessAppointment();
  }, [selectedBranch]);

  useEffect(() => {
    const filtered = allAppointments.filter((appointments) => {
      const nameMatch = appointments?.ref
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const serviceMatch = appointments?.service
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const teamMatch = appointments?.teamMember
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const statusMatch = appointments?.status
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const usernameMatch = appointments?.createdBy
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      return (
        nameMatch || serviceMatch || teamMatch || statusMatch || usernameMatch
      );
    });
    setFilteredAppointments(filtered);
  }, [allAppointments, searchInput]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleDatesChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleFetchBusinessAppointment = async () => {
    try {
      let payload = {
        startDate: startDate,
        endDate: endDate,
        branchId: selectedBranch,
      };

      setIsLoading(true);
      const response = await fetchAllAppointments(payload);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response?.data?.data;
        let sortedAppointments = data.sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
        );

        setAllAppointments(sortedAppointments);
      } else {
        handleCloseSnackbar(true, "error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerror");
      handleCloseSnackbar(true, "error", error?.data?.message);
    }
  };

  return (
    <>
      <AppContainer
        primaryHeading={"Appointments"}
        secondaryHeading={
          "View, filter and export appointments booked by your clients"
        }
        showSerach
        onChange={(e) => setSearchInput(e.target.value)}
        searchValue={searchInput}
        showSerachButton={true}
        handleSearch={handleFetchBusinessAppointment}
        showDateRange={
          <CustomRangePicker
            stackProps={{
              boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
              borderRadius: "6px",
            }}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            handleDatesChange={handleDatesChange}
          />
        }
      >
        {filteredAppointments?.length > 0 ? (
          <DynamicTable
            tableHeader={headerData}
            displayRows={tableRows}
            tableData={filteredAppointments}
          />
        ) : (
          <Typography
            fontSize={18}
            color={"#000"}
            textAlign={"center"}
            mb={20}
            mt={20}
          >
            No Appointment Found!
          </Typography>
        )}
      </AppContainer>
      <ClientOwnerFilterDialog ref={openDialog} />
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </>
  );
}

export default Appointments;
